/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RecoverAccountRouteImport } from './routes/recover-account'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedTeamRouteImport } from './routes/_authed.team'
import { Route as AuthedStreamRouteImport } from './routes/_authed.stream'
import { Route as AuthedSettingsRouteImport } from './routes/_authed.settings'
import { Route as AuthedSchedulesRouteImport } from './routes/_authed.schedules'
import { Route as AuthedRunsRouteImport } from './routes/_authed.runs'
import { Route as AuthedProfileRouteImport } from './routes/_authed.profile'
import { Route as AuthedFunctionsRouteImport } from './routes/_authed.functions'
import { Route as AuthedEventsRouteImport } from './routes/_authed.events'
import { Route as AuthedBillingRouteImport } from './routes/_authed.billing'
import { Route as AuthedAuditRouteImport } from './routes/_authed.audit'
import { Route as AuthedAppsRouteImport } from './routes/_authed.apps'
import { Route as AuthedRunsIndexRouteImport } from './routes/_authed.runs.index'
import { Route as AuthedFunctionsIndexRouteImport } from './routes/_authed.functions.index'
import { Route as AuthedEventsIndexRouteImport } from './routes/_authed.events.index'
import { Route as AuthedAppsIndexRouteImport } from './routes/_authed.apps.index'
import { Route as AuthedRunsIdRouteImport } from './routes/_authed.runs.$id'
import { Route as AuthedFunctionsIdRouteImport } from './routes/_authed.functions.$id'
import { Route as AuthedEventsIdRouteImport } from './routes/_authed.events.$id'
import { Route as AuthedAppsIdRouteImport } from './routes/_authed.apps.$id'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoverAccountRoute = RecoverAccountRouteImport.update({
  id: '/recover-account',
  path: '/recover-account',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeamRoute = AuthedTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStreamRoute = AuthedStreamRouteImport.update({
  id: '/stream',
  path: '/stream',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSchedulesRoute = AuthedSchedulesRouteImport.update({
  id: '/schedules',
  path: '/schedules',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRunsRoute = AuthedRunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFunctionsRoute = AuthedFunctionsRouteImport.update({
  id: '/functions',
  path: '/functions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEventsRoute = AuthedEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBillingRoute = AuthedBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditRoute = AuthedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAppsRoute = AuthedAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRunsIndexRoute = AuthedRunsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRunsRoute,
} as any)
const AuthedFunctionsIndexRoute = AuthedFunctionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedFunctionsRoute,
} as any)
const AuthedEventsIndexRoute = AuthedEventsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedEventsRoute,
} as any)
const AuthedAppsIndexRoute = AuthedAppsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAppsRoute,
} as any)
const AuthedRunsIdRoute = AuthedRunsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedRunsRoute,
} as any)
const AuthedFunctionsIdRoute = AuthedFunctionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedFunctionsRoute,
} as any)
const AuthedEventsIdRoute = AuthedEventsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedEventsRoute,
} as any)
const AuthedAppsIdRoute = AuthedAppsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedAppsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/login': typeof LoginRoute
  '/recover-account': typeof RecoverAccountRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/apps': typeof AuthedAppsRouteWithChildren
  '/audit': typeof AuthedAuditRoute
  '/billing': typeof AuthedBillingRoute
  '/events': typeof AuthedEventsRouteWithChildren
  '/functions': typeof AuthedFunctionsRouteWithChildren
  '/profile': typeof AuthedProfileRoute
  '/runs': typeof AuthedRunsRouteWithChildren
  '/schedules': typeof AuthedSchedulesRoute
  '/settings': typeof AuthedSettingsRoute
  '/stream': typeof AuthedStreamRoute
  '/team': typeof AuthedTeamRoute
  '/apps/$id': typeof AuthedAppsIdRoute
  '/events/$id': typeof AuthedEventsIdRoute
  '/functions/$id': typeof AuthedFunctionsIdRoute
  '/runs/$id': typeof AuthedRunsIdRoute
  '/apps/': typeof AuthedAppsIndexRoute
  '/events/': typeof AuthedEventsIndexRoute
  '/functions/': typeof AuthedFunctionsIndexRoute
  '/runs/': typeof AuthedRunsIndexRoute
}
export interface FileRoutesByTo {
  '/accept-invitation': typeof AcceptInvitationRoute
  '/login': typeof LoginRoute
  '/recover-account': typeof RecoverAccountRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/audit': typeof AuthedAuditRoute
  '/billing': typeof AuthedBillingRoute
  '/profile': typeof AuthedProfileRoute
  '/schedules': typeof AuthedSchedulesRoute
  '/settings': typeof AuthedSettingsRoute
  '/stream': typeof AuthedStreamRoute
  '/team': typeof AuthedTeamRoute
  '/': typeof AuthedIndexRoute
  '/apps/$id': typeof AuthedAppsIdRoute
  '/events/$id': typeof AuthedEventsIdRoute
  '/functions/$id': typeof AuthedFunctionsIdRoute
  '/runs/$id': typeof AuthedRunsIdRoute
  '/apps': typeof AuthedAppsIndexRoute
  '/events': typeof AuthedEventsIndexRoute
  '/functions': typeof AuthedFunctionsIndexRoute
  '/runs': typeof AuthedRunsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/login': typeof LoginRoute
  '/recover-account': typeof RecoverAccountRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_authed/apps': typeof AuthedAppsRouteWithChildren
  '/_authed/audit': typeof AuthedAuditRoute
  '/_authed/billing': typeof AuthedBillingRoute
  '/_authed/events': typeof AuthedEventsRouteWithChildren
  '/_authed/functions': typeof AuthedFunctionsRouteWithChildren
  '/_authed/profile': typeof AuthedProfileRoute
  '/_authed/runs': typeof AuthedRunsRouteWithChildren
  '/_authed/schedules': typeof AuthedSchedulesRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/stream': typeof AuthedStreamRoute
  '/_authed/team': typeof AuthedTeamRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/apps/$id': typeof AuthedAppsIdRoute
  '/_authed/events/$id': typeof AuthedEventsIdRoute
  '/_authed/functions/$id': typeof AuthedFunctionsIdRoute
  '/_authed/runs/$id': typeof AuthedRunsIdRoute
  '/_authed/apps/': typeof AuthedAppsIndexRoute
  '/_authed/events/': typeof AuthedEventsIndexRoute
  '/_authed/functions/': typeof AuthedFunctionsIndexRoute
  '/_authed/runs/': typeof AuthedRunsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invitation'
    | '/login'
    | '/recover-account'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/apps'
    | '/audit'
    | '/billing'
    | '/events'
    | '/functions'
    | '/profile'
    | '/runs'
    | '/schedules'
    | '/settings'
    | '/stream'
    | '/team'
    | '/apps/$id'
    | '/events/$id'
    | '/functions/$id'
    | '/runs/$id'
    | '/apps/'
    | '/events/'
    | '/functions/'
    | '/runs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accept-invitation'
    | '/login'
    | '/recover-account'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/audit'
    | '/billing'
    | '/profile'
    | '/schedules'
    | '/settings'
    | '/stream'
    | '/team'
    | '/'
    | '/apps/$id'
    | '/events/$id'
    | '/functions/$id'
    | '/runs/$id'
    | '/apps'
    | '/events'
    | '/functions'
    | '/runs'
  id:
    | '__root__'
    | '/_authed'
    | '/accept-invitation'
    | '/login'
    | '/recover-account'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/_authed/apps'
    | '/_authed/audit'
    | '/_authed/billing'
    | '/_authed/events'
    | '/_authed/functions'
    | '/_authed/profile'
    | '/_authed/runs'
    | '/_authed/schedules'
    | '/_authed/settings'
    | '/_authed/stream'
    | '/_authed/team'
    | '/_authed/'
    | '/_authed/apps/$id'
    | '/_authed/events/$id'
    | '/_authed/functions/$id'
    | '/_authed/runs/$id'
    | '/_authed/apps/'
    | '/_authed/events/'
    | '/_authed/functions/'
    | '/_authed/runs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  LoginRoute: typeof LoginRoute
  RecoverAccountRoute: typeof RecoverAccountRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recover-account': {
      id: '/recover-account'
      path: '/recover-account'
      fullPath: '/recover-account'
      preLoaderRoute: typeof RecoverAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/team': {
      id: '/_authed/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AuthedTeamRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/stream': {
      id: '/_authed/stream'
      path: '/stream'
      fullPath: '/stream'
      preLoaderRoute: typeof AuthedStreamRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/schedules': {
      id: '/_authed/schedules'
      path: '/schedules'
      fullPath: '/schedules'
      preLoaderRoute: typeof AuthedSchedulesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/runs': {
      id: '/_authed/runs'
      path: '/runs'
      fullPath: '/runs'
      preLoaderRoute: typeof AuthedRunsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/functions': {
      id: '/_authed/functions'
      path: '/functions'
      fullPath: '/functions'
      preLoaderRoute: typeof AuthedFunctionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/events': {
      id: '/_authed/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof AuthedEventsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/billing': {
      id: '/_authed/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthedBillingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/audit': {
      id: '/_authed/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthedAuditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/apps': {
      id: '/_authed/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AuthedAppsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/runs/': {
      id: '/_authed/runs/'
      path: '/'
      fullPath: '/runs/'
      preLoaderRoute: typeof AuthedRunsIndexRouteImport
      parentRoute: typeof AuthedRunsRoute
    }
    '/_authed/functions/': {
      id: '/_authed/functions/'
      path: '/'
      fullPath: '/functions/'
      preLoaderRoute: typeof AuthedFunctionsIndexRouteImport
      parentRoute: typeof AuthedFunctionsRoute
    }
    '/_authed/events/': {
      id: '/_authed/events/'
      path: '/'
      fullPath: '/events/'
      preLoaderRoute: typeof AuthedEventsIndexRouteImport
      parentRoute: typeof AuthedEventsRoute
    }
    '/_authed/apps/': {
      id: '/_authed/apps/'
      path: '/'
      fullPath: '/apps/'
      preLoaderRoute: typeof AuthedAppsIndexRouteImport
      parentRoute: typeof AuthedAppsRoute
    }
    '/_authed/runs/$id': {
      id: '/_authed/runs/$id'
      path: '/$id'
      fullPath: '/runs/$id'
      preLoaderRoute: typeof AuthedRunsIdRouteImport
      parentRoute: typeof AuthedRunsRoute
    }
    '/_authed/functions/$id': {
      id: '/_authed/functions/$id'
      path: '/$id'
      fullPath: '/functions/$id'
      preLoaderRoute: typeof AuthedFunctionsIdRouteImport
      parentRoute: typeof AuthedFunctionsRoute
    }
    '/_authed/events/$id': {
      id: '/_authed/events/$id'
      path: '/$id'
      fullPath: '/events/$id'
      preLoaderRoute: typeof AuthedEventsIdRouteImport
      parentRoute: typeof AuthedEventsRoute
    }
    '/_authed/apps/$id': {
      id: '/_authed/apps/$id'
      path: '/$id'
      fullPath: '/apps/$id'
      preLoaderRoute: typeof AuthedAppsIdRouteImport
      parentRoute: typeof AuthedAppsRoute
    }
  }
}

interface AuthedAppsRouteChildren {
  AuthedAppsIdRoute: typeof AuthedAppsIdRoute
  AuthedAppsIndexRoute: typeof AuthedAppsIndexRoute
}

const AuthedAppsRouteChildren: AuthedAppsRouteChildren = {
  AuthedAppsIdRoute: AuthedAppsIdRoute,
  AuthedAppsIndexRoute: AuthedAppsIndexRoute,
}

const AuthedAppsRouteWithChildren = AuthedAppsRoute._addFileChildren(
  AuthedAppsRouteChildren,
)

interface AuthedEventsRouteChildren {
  AuthedEventsIdRoute: typeof AuthedEventsIdRoute
  AuthedEventsIndexRoute: typeof AuthedEventsIndexRoute
}

const AuthedEventsRouteChildren: AuthedEventsRouteChildren = {
  AuthedEventsIdRoute: AuthedEventsIdRoute,
  AuthedEventsIndexRoute: AuthedEventsIndexRoute,
}

const AuthedEventsRouteWithChildren = AuthedEventsRoute._addFileChildren(
  AuthedEventsRouteChildren,
)

interface AuthedFunctionsRouteChildren {
  AuthedFunctionsIdRoute: typeof AuthedFunctionsIdRoute
  AuthedFunctionsIndexRoute: typeof AuthedFunctionsIndexRoute
}

const AuthedFunctionsRouteChildren: AuthedFunctionsRouteChildren = {
  AuthedFunctionsIdRoute: AuthedFunctionsIdRoute,
  AuthedFunctionsIndexRoute: AuthedFunctionsIndexRoute,
}

const AuthedFunctionsRouteWithChildren = AuthedFunctionsRoute._addFileChildren(
  AuthedFunctionsRouteChildren,
)

interface AuthedRunsRouteChildren {
  AuthedRunsIdRoute: typeof AuthedRunsIdRoute
  AuthedRunsIndexRoute: typeof AuthedRunsIndexRoute
}

const AuthedRunsRouteChildren: AuthedRunsRouteChildren = {
  AuthedRunsIdRoute: AuthedRunsIdRoute,
  AuthedRunsIndexRoute: AuthedRunsIndexRoute,
}

const AuthedRunsRouteWithChildren = AuthedRunsRoute._addFileChildren(
  AuthedRunsRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAppsRoute: typeof AuthedAppsRouteWithChildren
  AuthedAuditRoute: typeof AuthedAuditRoute
  AuthedBillingRoute: typeof AuthedBillingRoute
  AuthedEventsRoute: typeof AuthedEventsRouteWithChildren
  AuthedFunctionsRoute: typeof AuthedFunctionsRouteWithChildren
  AuthedProfileRoute: typeof AuthedProfileRoute
  AuthedRunsRoute: typeof AuthedRunsRouteWithChildren
  AuthedSchedulesRoute: typeof AuthedSchedulesRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedStreamRoute: typeof AuthedStreamRoute
  AuthedTeamRoute: typeof AuthedTeamRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAppsRoute: AuthedAppsRouteWithChildren,
  AuthedAuditRoute: AuthedAuditRoute,
  AuthedBillingRoute: AuthedBillingRoute,
  AuthedEventsRoute: AuthedEventsRouteWithChildren,
  AuthedFunctionsRoute: AuthedFunctionsRouteWithChildren,
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedRunsRoute: AuthedRunsRouteWithChildren,
  AuthedSchedulesRoute: AuthedSchedulesRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedStreamRoute: AuthedStreamRoute,
  AuthedTeamRoute: AuthedTeamRoute,
  AuthedIndexRoute: AuthedIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
  LoginRoute: LoginRoute,
  RecoverAccountRoute: RecoverAccountRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
